import {createContext} from "react";
import type {Editor} from "slate";

interface RestorableCoeditingSnapshot {
    title: string;
    prefix: string;
    selection: string;
    suffix: string;
}

export type CoeditorState = Readonly<{
    // Current Slate editor instance.
    editor: Editor | null;
    // Whether the coeditor is open.
    open: boolean;
    // The placeholder within the template that is currently being
    // filled-in during the initial completion. Empty if there is none.
    currentPlaceholderKey: string;
    // Whether the coeditor is read-only.
    readOnly: boolean;
    // Current title of the document.
    documentTitle: string;
    // Whether Khanmigo is currently typing into the editor.
    isKhanmigoTyping: boolean;
}>;

/**
 * Context that keeps track of the current external state of the Coeditor.
 */
export const CoeditorContext: React.Context<CoeditorState> =
    createContext<CoeditorState>({
        editor: null,
        open: false,
        currentPlaceholderKey: "",
        readOnly: false,
        documentTitle: "",
        isKhanmigoTyping: false,
    });

export type CoeditorAPI = Readonly<{
    reset: () => void;
    setReadOnly: (readOnly: boolean) => void;
    setDocumentTitle: (newTitle: string) => void;
    restoreSnapshot: (snapshot: RestorableCoeditingSnapshot) => void;
}>;

/**
 * Context providing an API for updating the external state of the Coeditor.
 */
export const CoeditorAPIContext: React.Context<CoeditorAPI> =
    createContext<CoeditorAPI>({
        reset: () => {},
        setReadOnly: () => {},
        setDocumentTitle: () => {},
        restoreSnapshot: () => {},
    });
